import { ref, onMounted } from 'vue';
import { useProductStore } from '../stores';
import { useLaboratoryStore } from '../stores';
import { useCategoryStore } from '../stores/categoryStore';
import { useNotificationStore } from '../stores/notificationStore';
import { useAuthStore } from '../stores/authStore';

export function useInitialLoad() {
  const isLoading = ref(true);
  const productStore = useProductStore();
  const laboratoryStore = useLaboratoryStore();
  const categoryStore = useCategoryStore();
  const notificationStore = useNotificationStore();
  const authStore = useAuthStore();

  onMounted(async () => {
    // Only load data if user is authenticated
    if (authStore.user) {
      try {
        await Promise.all([
          categoryStore.fetchCategories(),
          laboratoryStore.fetchLaboratories(),
          productStore.fetchProducts(),
        ]);
        notificationStore.success('Datos cargados correctamente');
      } catch (error) {
        notificationStore.error('Error al cargar los datos');
      }
    }
    isLoading.value = false;
  });

  return {
    isLoading
  };
}